import React from "react"
import {
    Container,
    Col,
    Row
  } from 'reactstrap';

function ElectionTypes(){
    return(
        <Container>
            <Row>
                <Col>
                <h2 className="display-3">Fast facts</h2>
                <ol>
                <li>There are over 830 million registered voters in India’s 2 month long elections.</li>
                <li>Leader name is currently Europe’s longest-serving leader.</li>
                <li>Country name has the longest time span between elections of  ___ years.</li>
                <li>New Zealand was the first country in the world to adopt universal suffrage (universal freedom to vote).</li>
                <li>Country name has the most number of seats in parliament at ____.</li>
                <li>Country name has the most number of people per representative at _____.</li>
                <li>Country name has the fewest number of people per representative at _____.</li>
                <li>Country name is the smallest country in the world with presidential elections.</li>
                <li>Was the first country in the world to fully adopt electronic voting.</li>
                <li>Was the first country in Africa to adopt universal suffrage - in ____.</li>
                <li>Was the last country in Europe to adopt universal suffrage - in _____</li>
                <li>Country names have the youngest voting age in the world at __16__</li>
                <li>Country names have the oldest voting age in the world at __21__</li>
                <li>Was the first country in the world to allow all prisoners to vote</li>
                <li>Had the highest election turnout in their last elections</li>
                <li>Had the lowest election turnout in their last elections</li>
                <li>Country name currently has the longest-serving leader in power</li>
                <li>___% of countries around the world have a prime minister</li>
                <li>___% of countries around the world have a president</li>
                </ol>
                </Col>
            </Row>
        </Container>
    )
}

export default ElectionTypes